import { render } from "./KanbanView.vue?vue&type=template&id=1a7050e1"
import script from "./KanbanView.vue?vue&type=script&lang=js"
export * from "./KanbanView.vue?vue&type=script&lang=js"

import "./KanbanView.vue?vue&type=style&index=0&id=1a7050e1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__